export default __webpack_public_path__ + "static/media/user.f64b4038.svg";